export default "__VITE_ASSET__ZEYRu3a1CbVDbnF3PvrLmw__"